<template>
  <div class="classify">
    <!-- <div class="mainTitle" >科目课程</div> -->
    <div class="Classification-management">
      <div style="display: flex" v-auth="'/subject/addSubjectCourse'">
        <el-input
          style="width: 200px; margin-right: 20px"
          placeholder="输入关键字进行过滤"
          v-model="filterText"
        ></el-input>
        <el-button
          type="primary"
          native-type="submit"
          @click="addFormVisible = true"
          >添加科目类型</el-button
        >
      </div>
      <div
        style="
          margin-top: 20px;
          border: 1px solid rgba(232, 245, 253);
          border-bottom: 0px;
        "
      >
        <!-- <div class="title">分类</div> -->
        <div class="block">
          <el-tree
            v-loading="webLoading"
            :data="pageList"
            ref="tree"
            node-key="id"
            :expand-on-click-node="false"
            :render-content="renderContent"
            :default-expand-all="false"
            :filter-node-method="filterNode"
          ></el-tree>
        </div>
      </div>
    </div>
    <!------------------------------------------ 添加 ------------------------------------------->
    <el-dialog
      title="添加科目类型"
      :visible.sync="addFormVisible"
      width="500px"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addRules"
      >
        <el-form-item label="科目类型" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>

        <el-form-item label="显示排序" prop="sort" v-model="addForm.sort">
          <el-input v-model.number="addForm.sort"></el-input>
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input
            v-model="addForm.remark"
            type="textarea"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="state">
          <!-- <el-switch v-model="addForm.state" active-color="#13ce66" inactive-color="#ff4949"></el-switch> -->
          <el-switch
            v-model="addForm.state"
            class="switchStyle wz"
            :active-value="1"
            :inactive-value="-1"
            active-text="开"
            inactive-text="关"
          ></el-switch>
        </el-form-item>
        <el-form-item label="题库启用" prop="display">
          <!-- <el-switch v-model="addForm.state" active-color="#13ce66" inactive-color="#ff4949"></el-switch> -->
          <el-switch
            v-model="addForm.display"
            class="switchStyle wz"
            :active-value="1"
            :inactive-value="-1"
            active-text="开"
            inactive-text="关"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="resetForm('addForm')">重 置</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>

    <!------------------------------------------ 编辑 ------------------------------------------->
    <el-dialog
      title="编辑科目类型"
      :visible.sync="editFormVisible"
      width="500px"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="addRules"
      >
        <el-form-item label="科目类型" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="显示排序" prop="sort" v-model="editForm.sort">
          <el-input v-model.number="editForm.sort"></el-input>
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input
            v-model="editForm.remark"
            type="textarea"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="state">
          <!-- <el-switch
            v-model="editForm.state==1?true:false"
            @change="changeState()"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>-->
          <el-switch
            v-model="editForm.state"
            class="switchStyle wz"
            :active-value="1"
            :inactive-value="-1"
            active-text="开"
            inactive-text="关"
          ></el-switch>
          <!-- @change="changeState()" -->
        </el-form-item>
        <el-form-item label="题库启用" prop="display">
          <!-- <el-switch v-model="addForm.state" active-color="#13ce66" inactive-color="#ff4949"></el-switch> -->
          <el-switch
            v-model="editForm.display"
            class="switchStyle wz"
            :active-value="1"
            :inactive-value="-1"
            active-text="开"
            inactive-text="关"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          type="primary"
          @click="submitEdit"
          v-auth="'/subject/editBtn'"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!------------------------------------------ 添加 ------------------------------------------->
    <el-dialog title="添加科目" :visible.sync="addFormVisible1" width="500px">
      <el-form
        ref="addForm1"
        :model="addForm1"
        label-width="80px"
        :rules="addRules1"
      >
        <!-- <el-form-item label="科目类型" label-width="80px" prop="pid">
          <el-select v-model="addForm.pid" placeholder="请选择">
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="科目名称" prop="name">
          <el-input v-model="addForm1.name"></el-input>
        </el-form-item>
        <el-form-item label="科目简称" prop="shortName">
          <el-input
            placeholder="请输入科目简称（初级会计实务：KJSW）"
            v-model="addForm1.shortName"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="类型编号" prop="number">
          <el-input v-model.number="addForm1.number"></el-input>
        </el-form-item>-->
        <el-form-item label="显示排序" prop="sort" v-model="addForm1.sort">
          <el-input v-model.number="addForm1.sort"></el-input>
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input
            v-model="addForm1.remark"
            type="textarea"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="state">
          <!-- <el-switch v-model="addForm1.state" active-color="#13ce66" inactive-color="#ff4949"></el-switch> -->
          <el-switch
            v-model="addForm1.state"
            class="switchStyle wz"
            :active-value="1"
            :inactive-value="-1"
            active-text="开"
            inactive-text="关"
          ></el-switch>
        </el-form-item>
        <el-form-item label="题库启用" prop="display">
          <!-- <el-switch v-model="addForm.state" active-color="#13ce66" inactive-color="#ff4949"></el-switch> -->
          <el-switch
            v-model="addForm1.display"
            class="switchStyle wz"
            :active-value="1"
            :inactive-value="-1"
            active-text="开"
            inactive-text="关"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="resetForm('addForm1')">重 置</el-button>
        <el-button type="primary" @click="submitAdd1" v-auth="'/subject/addBtn'"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!------------------------------------------ 编辑 ------------------------------------------->
    <el-dialog title="编辑科目" :visible.sync="editFormVisible1" width="500px">
      <el-form
        ref="editForm1"
        :model="editForm1"
        label-width="80px"
        :rules="addRules1"
      >
        <!-- <el-form-item label="科目类型" label-width="80px" prop="pid">
          <el-select v-model="editForm1.pid" placeholder="请选择">
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="所属科目" prop="pid">
          <!-- <el-input v-model="editForm1.pid"></el-input> -->
          <el-select
            v-model="editForm1.pid"
            class="selectss"
            style="width: 100% !important"
            placeholder="请选择"
          >
            <el-option
              v-for="item in pidList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目名称" prop="name">
          <el-input v-model="editForm1.name"></el-input>
        </el-form-item>
        <el-form-item label="科目简称" prop="shortName">
          <el-input
            placeholder="请输入科目简称（初级会计实务：KJSW）"
            v-model="editForm1.shortName"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="类型编号" prop="number">
          <el-input v-model.number="editForm1.number" :disabled="true"></el-input>
        </el-form-item>-->
        <el-form-item label="显示排序" prop="sort" v-model="editForm1.sort">
          <el-input v-model.number="editForm1.sort"></el-input>
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input
            v-model="editForm1.remark"
            type="textarea"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="state">
          <!-- <el-switch
            @change="changeState1()"
            v-model="editForm1.state==1?true:false"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>-->
          <el-switch
            v-model="editForm1.state"
            class="switchStyle wz"
            :active-value="1"
            :inactive-value="-1"
            active-text="开"
            inactive-text="关"
          ></el-switch>
          <!-- @change="changeState1()" -->
        </el-form-item>
        <el-form-item label="题库启用" prop="display">
          <!-- <el-switch v-model="addForm.state" active-color="#13ce66" inactive-color="#ff4949"></el-switch> -->
          <el-switch
            v-model="editForm1.display"
            class="switchStyle wz"
            :active-value="1"
            :inactive-value="-1"
            active-text="开"
            inactive-text="关"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          type="primary"
          @click="submitEdit1"
          v-auth="'/subject/editBtn'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!------------------------------------------ 添加 ------------------------------------------->
    <el-dialog
      title="添加具体课程"
      :visible.sync="addFormVisible2"
      width="500px"
    >
      <el-form
        ref="addForm2"
        :model="addForm2"
        label-width="80px"
        :rules="addRules2"
      >
        <el-form-item label="课程名称" prop="name">
          <el-input v-model="addForm2.name"></el-input>
        </el-form-item>
        <el-form-item
          placeholder="请输入课程简称（初级会计实务：KJSW）"
          label="课程简称"
          prop="shortName"
        >
          <el-input v-model="addForm2.shortName"></el-input>
        </el-form-item>
        <!-- <el-form-item label="类型编号" prop="number">
          <el-input v-model.number="addForm2.number"></el-input>
        </el-form-item>-->
        <el-form-item label="显示排序" prop="sort" v-model="addForm2.sort">
          <el-input v-model.number="addForm2.sort"></el-input>
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input
            v-model="addForm2.remark"
            type="textarea"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="state">
          <!-- <el-switch v-model="addForm2.state" active-color="#13ce66" inactive-color="#ff4949"></el-switch> -->
          <el-switch
            v-model="addForm2.state"
            class="switchStyle wz"
            :active-value="1"
            :inactive-value="-1"
            active-text="开"
            inactive-text="关"
          ></el-switch>
        </el-form-item>
        <el-form-item label="题库启用" prop="display">
          <!-- <el-switch v-model="addForm.state" active-color="#13ce66" inactive-color="#ff4949"></el-switch> -->
          <el-switch
            v-model="addForm2.display"
            class="switchStyle wz"
            :active-value="1"
            :inactive-value="-1"
            active-text="开"
            inactive-text="关"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="resetForm('addForm2')">重 置</el-button>
        <el-button type="primary" @click="submitAdd2" v-auth="'/subject/addBtn'"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!------------------------------------------ 编辑 ------------------------------------------->
    <el-dialog
      title="编辑具体课程"
      :visible.sync="editFormVisible2"
      width="500px"
    >
      <el-form
        ref="editForm2"
        :model="editForm2"
        label-width="80px"
        :rules="addRules2"
      >
        <el-form-item label="所属科目" prop="pid">
          <!-- <el-input v-model="editForm1.pid"></el-input> -->
          <el-select
            v-model="editForm2.pid"
            class="selectss"
            style="width: 100% !important"
            placeholder="请选择"
          >
            <el-option
              v-for="item in pidList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程名称" prop="name">
          <el-input v-model="editForm2.name"></el-input>
        </el-form-item>
        <el-form-item
          placeholder="请输入课程简称（初级会计实务：KJSW）"
          label="课程简称"
          prop="shortName"
        >
          <el-input v-model="editForm2.shortName"></el-input>
        </el-form-item>
        <!-- <el-form-item label="课程编号" prop="number">
          <el-input v-model.number="editForm2.number" :disabled="true"></el-input>
        </el-form-item>-->
        <el-form-item label="显示排序" prop="sort" v-model="editForm2.sort">
          <el-input v-model.number="editForm2.sort"></el-input>
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input
            v-model="editForm2.remark"
            type="textarea"
            auto-complete="off"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="state">
          <!-- <el-switch
            @change="changeState2()"
            v-model="editForm2.state==1?true:false"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>-->
          <el-switch
            v-model="editForm2.state"
            class="switchStyle wz"
            :active-value="1"
            :inactive-value="-1"
            active-text="开"
            inactive-text="关"
          ></el-switch>
          <!-- @change="changeState2()" -->
        </el-form-item>
        <el-form-item label="题库启用" prop="display">
          <!-- <el-switch v-model="addForm.state" active-color="#13ce66" inactive-color="#ff4949"></el-switch> -->
          <el-switch
            v-model="editForm2.display"
            class="switchStyle wz"
            :active-value="1"
            :inactive-value="-1"
            active-text="开"
            inactive-text="关"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          type="primary"
          @click="submitEdit2"
          v-auth="'/subject/editBtn'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pidList: [],
      filterText: "",
      addForm2: {
        level: 2,
        ppid: "",
        pid: "",
        name: "",
        number: "",
        sort: "",
        remark: "",
        shortName: "",
        state: 1,
        display: 1,
      },
      addRules2: {
        ppid: [
          { required: true, message: "请选择科目类型", trigger: "change" },
        ],
        pid: [{ required: true, message: "请选择所属科目", trigger: "change" }],
        name: [{ required: true, message: "请输入科目名称", trigger: "blur" }],
        shortName: [
          { required: true, message: "请输入课程简称", trigger: "blur" },
        ],
        number: [
          { required: true, message: "请输入类型编号", trigger: "blur" },
          { type: "number", message: "类型编号必须为数字" },
        ],
        sort: [
          { required: true, message: "请输入显示排序", trigger: "blur" },
          { type: "number", message: "显示排序必须为数字" },
        ],
      },
      addRules1: {
        pid: [{ required: true, message: "请输入科目类型", trigger: "change" }],
        name: [{ required: true, message: "请输入科目名称", trigger: "blur" }],
        shortName: [
          { required: true, message: "请输入科目简称", trigger: "blur" },
        ],

        number: [
          { required: true, message: "请输入类型编号", trigger: "blur" },
          { type: "number", message: "类型编号必须为数字" },
        ],
        sort: [
          { required: true, message: "请输入显示排序", trigger: "blur" },
          { type: "number", message: "显示排序必须为数字" },
        ],
      },
      formLabelWidth: "80px",
      editForm1: {},
      editForm: {},
      editParam: {},
      label: "1",
      editFormVisible: false,
      webLoading: false,
      editFormVisible1: false,
      editFormVisible2: false,
      addFormVisible: false,
      searchParam: {
        name: "",
        level: 0,
        pageSize: 10,
        pageNumber: 1,
      },
      param: {
        name: "",
        level: 0,
        pageSize: 10,
        pageNumber: 1,
      },
      addForm1: {
        level: 1,
        shortName: "",
        pid: "",
        name: "",
        number: "",
        sort: "",
        display: 1,
        remark: "",
        state: 1,
      },
      addForm: {
        level: 0,
        pid: 0,
        name: "",
        number: "",
        display: 1,
        sort: "",
        remark: "",
        level: 0,
        state: 1,
      },
      addRules: {
        name: [{ required: true, message: "请输入科目类型", trigger: "blur" }],
        number: [
          { required: true, message: "请输入类型编号", trigger: "blur" },
          { type: "number", message: "类型编号必须为数字" },
        ],
        sort: [
          { required: true, message: "请输入显示排序", trigger: "blur" },
          { type: "number", message: "显示排序必须为数字" },
        ],
      },
      list: [],
      returnVal: {},
      pageList: [],
      editForm2: {},
      addFormVisible: false,
      addFormVisible1: false,
      addFormVisible2: false,
      addname: "",
      Editname: "",
      apidata: "",
    };
  },
  created () { },
  mounted () {
    this.gitpageListZsk();
  },
  methods: {
    getPListByLevel (data, level) {
      console.log(data.pid, level);

      this.api.subjectCourse
        .getPListByLevel({
          level: level,
        })
        .then((result) => {
          if (result.code == 200) {
            this.pidList = result.data;
            if (level == 1) {
              this.editForm1 = JSON.parse(JSON.stringify(data));
              this.editForm1.pids = this.editForm1.pid;
              this.editFormVisible1 = true;
            } else if (level == 2) {
              this.editForm2 = JSON.parse(JSON.stringify(data));
              this.editForm2.pids = this.editForm2.pid;
              this.editFormVisible2 = true;
            }
          } else {
            this.pidList = [];
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    filterNode (value, data) {
      console.log(111, value);
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    changeState2 (e) {
      console.log(e);
      if (this.editForm2.state == -1) {
        // this.$confirm(
        //   "禁用此科目类型会把下属的科目和课程全部禁用,是否继续?",
        //   "提示",
        //   {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "warning"
        //   }
        // )
        //   .then(() => {
        this.api.subjectCourse
          .offSubjectCourse({
            id: this.editForm2.id,
          })
          .then((result) => {
            if (result.code == 200) {
              this.$message({
                message: result.message,
                type: "success",
              });
              this.editForm2.state = -1;
            } else {
              this.$message.error(result.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
        // })
        // .catch(() => {
        //   this.$message({
        //     type: "info",
        //     message: "已取消"
        //   });
        // });
      } else {
        // this.$confirm(
        //   "开启此科目类型会把下属的科目和课程全部开启,是否继续?",
        //   "提示",
        //   {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "warning"
        //   }
        // )
        //   .then(() => {
        this.api.subjectCourse
          .onSubjectCourse({
            id: this.editForm2.id,
          })
          .then((result) => {
            if (result.code == 200) {
              this.$message({
                message: result.message,
                type: "success",
              });
              this.editForm2.state = 1;
            } else {
              this.$message.error(result.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
        // })
        // .catch(() => {
        //   this.$message({
        //     type: "info",
        //     message: "已取消"
        //   });
        // });
      }
    },
    submitEdit2 () {
      this.$refs.editForm2.validate((valid) => {
        if (valid) {
          this.api.subjectCourse
            .updateSubjectCourse(this.editForm2)
            .then((result) => {
              if (result.success) {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
                this.editFormVisible2 = false;
                // this.gitpageListZsk();
                this.setList(this.editForm2);

                if (this.editForm2.pid != this.editForm2.pids) {
                  this.gitpageListZsk();
                }
              } else {
                this.$message.error("操作失败，请重试");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    submitAdd2 () {
      this.$refs.addForm2.validate((valid) => {
        if (valid) {
          var param = this.addForm2;
          if (Number(this.addForm2.state) == 1) {
            param.state = 1;
          } else {
            param.state = -1;
          }
          this.api.subjectCourse
            .addSubjectCourse(param)
            .then((result) => {
              if (result.success) {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
                this.addFormVisible2 = false;
                this.gitpageListZsk();
              } else {
                this.$message.error("操作失败，请重试");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    submitEdit1 () {
      this.$refs.editForm1.validate((valid) => {
        if (valid) {
          this.api.subjectCourse
            .updateSubjectCourse(this.editForm1)
            .then((result) => {
              if (result.success) {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
                this.editFormVisible1 = false;
                // this.gitpageListZsk();
                this.setList(this.editForm1);

                // if (this.editForm1.pid != this.editForm1.pids) {
                  this.gitpageListZsk();
                // }
              } else {
                this.$message.error("操作失败，请重试");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    currentChange (pageNumber) {
      this.param.pageNumber = pageNumber;
      this.gitpageListZsk();
    },
    changeState1 () {
      if (this.editForm1.state == -1) {
        // this.$confirm(
        //   "禁用此科目类型会把下属的科目和课程全部禁用,是否继续?",
        //   "提示",
        //   {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "warning"
        //   }
        // )
        //   .then(() => {
        this.api.subjectCourse
          .offSubjectCourse({
            id: this.editForm1.id,
          })
          .then((result) => {
            this.$message({
              message: "恭喜你，操作成功",
              type: "success",
            });
            this.editForm1.state = -1;

            this.gitpageListZsk();
          })
          .catch((error) => {
            console.log(error);
          });
        // })
        // .catch(() => {
        //   this.$message({
        //     type: "info",
        //     message: "已取消"
        //   });
        // });
      } else {
        // this.$confirm(
        //   "开启此科目类型会把下属的科目和课程全部开启,是否继续?",
        //   "提示",
        //   {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "warning"
        //   }
        // )
        //   .then(() => {
        this.api.subjectCourse
          .onSubjectCourse({
            id: this.editForm1.id,
          })
          .then((result) => {
            this.$message({
              message: "恭喜你，操作成功",
              type: "success",
            });
            this.editForm1.state = 1;

            this.gitpageListZsk();
          })
          .catch((error) => {
            console.log(error);
          });
        // })
        // .catch(() => {
        //   this.$message({
        //     type: "info",
        //     message: "已取消"
        //   });
        // });
      }
    },
    changeState () {
      if (this.editForm.state == -1) {
        // this.$confirm(
        //   "禁用此科目类型会把下属的科目和课程全部禁用,是否继续?",
        //   "提示",
        //   {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "warning"
        //   }
        // )
        //   .then(() => {
        this.api.subjectCourse
          .offSubjectCourse({
            id: this.editForm.id,
          })
          .then((result) => {
            this.$message({
              message: "恭喜你，操作成功",
              type: "success",
            });
            this.editForm.state = -1;

            this.gitpageListZsk();
          })
          .catch((error) => {
            console.log(error);
          });
        // })
        // .catch(() => {
        //   this.$message({
        //     type: "info",
        //     message: "已取消"
        //   });
        // });
      } else {
        // this.$confirm(
        //   "开启此科目类型会把下属的科目和课程全部开启,是否继续?",
        //   "提示",
        //   {
        //     confirmButtonText: "确定",
        //     cancelButtonText: "取消",
        //     type: "warning"
        //   }
        // )
        //   .then(() => {
        this.api.subjectCourse
          .onSubjectCourse({
            id: this.editForm.id,
          })
          .then((result) => {
            this.$message({
              message: "恭喜你，操作成功",
              type: "success",
            });
            this.editForm.state = 1;

            this.gitpageListZsk();
          })
          .catch((error) => {
            console.log(error);
          });
        // })
        // .catch(() => {
        //   this.$message({
        //     type: "info",
        //     message: "已取消"
        //   });
        // });
      }
    },
    getSearchList () {
      this.param = JSON.parse(JSON.stringify(this.searchParam));
      this.api.subjectCourse
        .getPageList(this.searchParam)
        .then((result) => {
          this.list = result.data.records;
          this.returnVal = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    editBtn (list, sty) {
      if (sty == 0) {
        this.editFormVisible = true;
        this.editForm = JSON.parse(JSON.stringify(list));
      } else if (sty == 1) {
        this.getPListByLevel(list, sty);
      } else if (sty == 2) {
        this.getPListByLevel(list, sty);
      }
    },
    submitEdit () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.api.subjectCourse
            .updateSubjectCourse(this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
                this.editFormVisible = false;
                // this.gitpageListZsk();
                this.setList(this.editForm);
              } else {
                this.$message.error("操作失败，请重试");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    submitAdd () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          var param = this.addForm;
          if (Number(this.addForm.state) == 1) {
            param.state = 1;
          } else {
            param.state = -1;
          }
          this.api.subjectCourse
            .addSubjectCourse(param)
            .then((result) => {
              if (result.success) {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
                this.addFormVisible = false;
                this.gitpageListZsk();
              } else {
                this.$message.error("操作失败，请重试");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    submitAdd1 () {
      this.$refs.addForm1.validate((valid) => {
        if (valid) {
          var param = this.addForm1;
          if (Number(this.addForm1.state) == 1) {
            param.state = 1;
          } else {
            param.state = -1;
          }
          this.api.subjectCourse
            .addSubjectCourse(param)
            .then((result) => {
              if (result.success) {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
                this.addFormVisible1 = false;
                this.gitpageListZsk();
              } else {
                this.$message.error("操作失败，请重试");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    //重置表格
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    handleClose (done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    // 获取分类列表
    gitpageListZsk () {
      this.webLoading = true;
      this.api
        .getSubjectCourseAllTree()
        .then((result) => {
          this.webLoading = false;
          for (let item of result.data) {
            if (item.state == 1) {
              item.sty = true;
            } else {
              item.sty = false;
            }
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.state == 1) {
                  items.sty = true;
                } else {
                  items.sty = false;
                }
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.state == 1) {
                      itemss.sty = true;
                    } else {
                      itemss.sty = false;
                    }
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.pageList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    aaa (data, sty) {
      if (sty == 0) {
        this.addForm1 = {
          level: 1,
          shortName: "",
          pid: "",
          name: "",
          number: "",
          sort: "",
          display: 1,
          remark: "",
          state: 1,
        };
        this.addForm1.pid = data.id;
        this.addFormVisible1 = true;
      } else {
        this.addForm2 = {
          level: 2,
          ppid: "",
          pid: "",
          name: "",
          number: "",
          sort: "",
          remark: "",
          shortName: "",
          state: 1,
          display: 1,
        };
        this.addForm2.pid = data.id;
        this.addFormVisible2 = true;
      }
    },
    deleteBtn (list, sty) {
      this.$confirm(
        "删除将导致下属题库和视频无法使用，请确认后删除。",
        "系统消息",
        {
          type: "warning",
        }
      )
        .then(() => {
          // this.api.exam
          //   .deleteExam(this.ids)
          //   .then(result => {
          //     if (result.success) {
          //       this.$message({
          //         type: "success",
          //         message: result.message
          //       });
          //       this.pageList();
          //     } else {
          //       this.$message.error(result.message);
          //     }
          //   })
          //   .catch(error => {
          //     console.log(error);
          //   });
        })
        .catch(() => { });
    },
    setList (data) {
      this.pageList.map((item, index) => {
        if (data.id == item.id) {
          console.log("1111   ", data);

          this.pageList[index].name = data.name;
          this.pageList[index].sort = data.sort;
          this.pageList[index].remark = data.remark;
          this.pageList[index].state = data.state;
          this.pageList[index].display = data.display;
          return (item = data);
        } else {
          item.children.map((item1, index1) => {
            if (data.id == item1.id) {
              console.log("1111   ", data);
              // this.pageList[index].children[index1] = data;
              this.pageList[index].children[index1].name = data.name;
              this.pageList[index].children[index1].sort = data.sort;
              this.pageList[index].children[index1].remark = data.remark;
              this.pageList[index].children[index1].state = data.state;
              this.pageList[index].children[index1].display = data.display;
              this.pageList[index].children[index1].pid = data.pid;
              return (item1 = data);
            } else {
              item1.children.map((item2, index2) => {
                if (data.id == item2.id) {
                  // this.pageList[index].children[index1].children[index2] = data;
                  this.pageList[index].children[index1].children[index2].name =
                    data.name;
                  this.pageList[index].children[index1].children[index2].sort =
                    data.sort;
                  this.pageList[index].children[index1].children[
                    index2
                  ].remark = data.remark;
                  this.pageList[index].children[index1].children[index2].state =
                    data.state;
                  this.pageList[index].children[index1].children[
                    index2
                  ].display = data.display;
                  this.pageList[index].children[index1].children[index2].pid =
                    data.pid;
                  console.log("1111   ", data);
                  return (item2 = data);
                }
              });
            }
          });
        }
      });
      console.log("2222   ", this.pageList);
    },
    renderContent (h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span>
            {node.data.name}
            {node.data.state == -1 ? <span class="re">[禁用]</span> : ""}
            {node.data.display == 1 ? "" : <span class="re">[题库禁用]</span>}
          </span>
          <span>
            {node.data.level != 2 ? (
              <el-button

                type="text"
                size="mini"
                on-click={() => this.aaa(node.data, node.data.level)}
              >
                <i class="iconfont iconicon-test bl" />
              </el-button>
            ) : (
              ""
            )}

            <el-button

              type="text"
              size="mini"
              on-click={() => this.editBtn(node.data, node.data.level)}
            >
              <i class="iconfont iconbianji bl" />
            </el-button>
          </span>
        </span>
      );
    },
    // <el-button
    //   type="text"
    //   size="mini"
    //   on-click={() => this.deleteBtn(node.data, node.data.level)}
    // >
    //   <i class="iconfont iconicon7 bl" />
    // </el-button>
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val);
    },
    "addForm.state" (val) {
      console.log(11, val);
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
.classify {
  width: 100%;
  height: 100%;
  overflow: auto;
  .el-dialog__footer {
    text-align: left;
  }
  .bl {
    color: rgb(64, 158, 255);
    margin-right: 20px;
  }
  .el-input {
    width: 200px;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .Classification-management {
    background: white;
    padding: 20px;
    .title {
      font-size: 14px;
      color: #333;
      padding: 0px 10px;
      font-weight: bold;
      height: 50px;
      line-height: 50px;
      background: rgb(233, 245, 253);
    }
    .block {
      .el-tree-node__content {
        height: 50px;
        border-bottom: 1px solid rgb(232, 245, 253);
      }
    }
  }
  .ge {
    color: rgb(36, 210, 181);
  }
  .re {
    color: rgb(255, 117, 107);
    margin-left: 4px;
  }
}
</style>
<style lang="less" scoped>
.el-input {
  width: 100%;
}
.wz {
  .el-switch__label--left {
    z-index: 9 !important;
    left: 8px !important;
  }
  .el-switch__label--right {
    z-index: 9 !important;
    left: -18px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subject/index.vue